import { buildAttributesWithName } from './buildAttributesWithName';
import { filterAndBuildContainers } from './filterAndBuildContainers';
import { isNotEmptyObject } from './isNotEmptyObject';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export function buildContainersWithName(containers: any):
	| {
			[name: string]: any;
	  }
	| undefined {
	if (isNotEmptyObject(containers)) {
		const validContainers = filterAndBuildContainers(containers);
		return buildAttributesWithName('containers', validContainers);
	}

	return undefined;
}
